import React from 'react';
import { MicroserviceClient, MicroservicesClientApi } from "@infobis/microservice-bridge/lib/types";
import { MicroserviceId } from "@infobis/microservice-bridge";

export type TClientApi = MicroservicesClientApi[keyof Pick<typeof MicroserviceId, "PARTNERS">]
export type TApiContext = MicroserviceClient<TClientApi['parameters'], TClientApi['events']>

export const ApiContext = React.createContext({} as TApiContext | undefined);